import * as React from 'react';
import { connect } from 'react-redux';
import FormList from './FormList';
import FormEdit from './FormEdit';
import { Alert } from 'react-bootstrap';
import { ResponseStatus, FormSaveStatus } from '../../../services/Enums/shared';
import * as urls from '../../shared/urls';
import { updateHeaderByComponent } from '../../Navigation/redux-objects/actions';
import moment from 'moment';
import * as linkify from 'linkifyjs';
import { IAppRouteLocation } from "../../../common/sharedTypes";

interface IFromAdminOwnProps {
	history:any;
	match:any;
	location:any;
}

interface IFormAdminPropsFromState {
	formIOBaseURL: string;
	webServiceURL: string;
}

interface IFormAdminPropsFromActions {
	updateHeaderByComponent: (newNav: string) => void;
}


interface IFormAdminLocalState {
	formToEdit: any;
	isEditing: boolean;
	allForms: any[];
	showAlert: boolean;
	status: FormSaveStatus;
}

type IFormAdminProps = IFormAdminPropsFromState & IFormAdminPropsFromActions & IFromAdminOwnProps;

class FormAdministrationController extends React.Component<IFormAdminProps, IFormAdminLocalState> {
	constructor(props) {
		super(props);
		this.state = {
			formToEdit: null,
			isEditing: false,
			allForms: [],
			showAlert: false,
			status: FormSaveStatus.Unset
		};
	}

	formSave = (formSchema) => {
		return fetch(this.props.webServiceURL + urls.SAVE_FORM_URL, {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formSchema)
		})
		.then((res) => res.json())
		.then((result) => {
			if (result.saveResult == 200) this.setState({ showAlert: true, status: FormSaveStatus.Success });
			else this.setState({ showAlert: true, status: FormSaveStatus.Failure });

			return result.formObject;
		});
	};

	setFormToEdit = (form) => {
		this.setState({ formToEdit: form, isEditing: true });
	};

	cancelFormEdit = () => {
		this.setState({ formToEdit: null, isEditing: false });
	};

	closeAlert = () => {
		this.setState({ showAlert: false, status: FormSaveStatus.Unset });
	};

	copyForm = (form) => {
		let location:IAppRouteLocation = {
			pathname:"/CreateForm"
		};
	
		let locationState:any = {};

		locationState.formURL = this.props.formIOBaseURL + form;
	
		location.state = locationState;
		this.props.history.push(location);
	}

	componentDidMount() {
		if (this.state.allForms.length == 0) {
			fetch(this.props.webServiceURL + urls.GET_FORM_IO_FORMS_URL).then((res) => res.json()).then((result) => {
				this.setState({ allForms: result });
			});
		}
	}

	render() {
		return (
			<React.Fragment>
				{!this.state.isEditing && (
					<FormList forms={this.state.allForms} selectFormToEdit={this.setFormToEdit} copyForm={this.copyForm} history={this.props.history} />
				)}

				{this.state.isEditing && (
					<React.Fragment>
						{this.state.showAlert &&
							this.state.status == FormSaveStatus.Success && (
								<Alert variant="success" dismissible onClose={() => this.closeAlert()}>
									Congratulations! {this.state.formToEdit.title} was saved successfully!
								</Alert>
						)}

						{this.state.showAlert &&
							this.state.status == FormSaveStatus.Failure && (
								<Alert variant="danger" dismissible onClose={() => this.closeAlert()}>
									Uh oh! There was an error saving the form: {this.state.formToEdit.title}!
								</Alert>
						)}
						
						<FormEdit
							formURL={this.state.formToEdit ? this.props.formIOBaseURL + this.state.formToEdit : ''}
							formSave={this.formSave}
							cancelEdit={this.cancelFormEdit}
							history={this.props.history}
						/>
					</React.Fragment>
				)}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (reduxState: any) => {
	return {
		formIOBaseURL: reduxState.Application.formIOUrl,
		webServiceURL: reduxState.Application.backendURL
	};
};

const mapDispatchToProps = {
	updateHeaderByComponent
};

export default connect<IFormAdminPropsFromState, IFormAdminPropsFromActions>(mapStateToProps, mapDispatchToProps)(
	FormAdministrationController
);
